module.exports = __webpack_public_path__ + "media/images/icons/linkedin-a55945a2bbc142af1354388124fe413c.svg";